import type { Group, Option } from './select-inline-edit/select-field/types.tsx';

export const isGroup = (optionOrGroup: Option | Group): boolean =>
	// @ts-expect-error - TS2339 - Property 'options' does not exist on type 'Option | Group'.
	optionOrGroup.options !== undefined;
